import { render, staticRenderFns } from "./CreateCenterCategoryPage.vue?vue&type=template&id=7cfe99dc&scoped=true"
import script from "./CreateCenterCategoryPage.vue?vue&type=script&lang=js"
export * from "./CreateCenterCategoryPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cfe99dc",
  null
  
)

export default component.exports